import * as angular from 'angular';

class Chips { }

angular.module('naut').component('chips', {
	template: require('./chips.component.html'),
	controller: Chips,
	controllerAs: 'ctrl',
	bindings: {
		onClick: '&',
		items: '=',
		displayField: '<',
		isDisabled: '<'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/chips/chips.component.ts